import Reveal from "@/components/base/Reveal";

const steps = [
  {
    icon: "ri-route-line",
    title: "先从一部“结构清楚”的看起",
    text: "片长适中、人物不多、单一主线的作品最容易进入状态，避免一上来就被群像和多时间线劝退。",
    hint: "可试：心灵捕手 / 她",
  },
  {
    icon: "ri-translate-2",
    title: "固定用一版中文字幕看完",
    text: "不要中途换字幕来源。同一版字幕的译名和称谓保持一致，人物关系才不会在中途变得混乱。",
    hint: "先对齐时间轴再开始",
  },
  {
    icon: "ri-chat-1-line",
    title: "看完留十分钟做一次复盘",
    text: "问自己：主角最关键的两次选择是什么？如果换一种选择，故事会怎样？这一步会明显提升理解深度。",
    hint: "写几句也行",
  },
  {
    icon: "ri-stack-line",
    title: "再按主题横向连着看",
    text: "把同一主题的两三部作品放在一起看，对比不同年代的拍法差异，会比单看一部收获更多。",
    hint: "用片单标签筛选",
  },
];

export default function StartGuide() {
  return (
    <section id="start" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <Reveal>
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-start">
            <div className="lg:col-span-4 lg:sticky lg:top-24">
              <span className="text-xs md:text-sm font-label tracking-widest text-primary-600 uppercase">Getting Started</span>
              <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
                入门路径：<br />四步找到自己的看法
              </h2>
              <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
                这类电影不追求信息轰炸，反而需要你把注意力放在人物之间。
                按下面这个顺序走，能更快建立属于自己的判断标准。
              </p>
              <div className="mt-6 rounded-lg bg-primary-500 p-5 text-background-50">
                <i className="ri-quote-text text-2xl text-primary-200"></i>
                <p className="mt-2 text-sm leading-relaxed">
                  先有感受，再找解释。看懂一部伦理电影，往往是从“我为什么不舒服”这个问题开始的。
                </p>
              </div>
            </div>

            <div className="lg:col-span-8 space-y-4">
              {steps.map((s, i) => (
                <Reveal key={s.title} delay={i * 70}>
                  <div className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-6 flex gap-5">
                    <div className="flex flex-col items-center shrink-0">
                      <span className="w-11 h-11 rounded-md bg-accent-500 text-background-50 flex items-center justify-center">
                        <i className={`${s.icon} text-xl`}></i>
                      </span>
                      <span className="mt-2 font-heading text-xs text-foreground-400">0{i + 1}</span>
                    </div>
                    <div className="flex-1">
                      <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950">{s.title}</h3>
                      <p className="mt-2 text-sm leading-relaxed text-foreground-600">{s.text}</p>
                      <span className="inline-flex items-center gap-1.5 mt-3 px-3 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs">
                        <i className="ri-bookmark-line"></i>
                        {s.hint}
                      </span>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}